import { useEffect } from "react";
import type { CdcUserAttributes } from "../models/cdcUser";
import { trackLogin } from "../service/tracking";
import type { UserAttributes } from "./authentication";
import { getAuthenticatedAxios } from "./authentication";

const SESSION_FLAG = "cf_login_tracked";

/**
 * Fires a single LOGIN tracking event per browser session once the user
 * becomes identified (either via Amplify/Cognito or via CDC/Gigya).
 *
 * Guarded by sessionStorage so page reloads inside the same session do not
 * produce duplicate login events. The flag is cleared on logout by
 * removeLoginTrackingFlag().
 */
export const useLoginTracking = (
  user: UserAttributes | undefined,
  cdcUser: CdcUserAttributes | undefined,
) => {
  useEffect(() => {
    const identified = user?.email ?? cdcUser?.email;
    if (!identified) return;
    if (sessionStorage.getItem(SESSION_FLAG) === "true") return;

    const { axios } = getAuthenticatedAxios();
    trackLogin(axios);
    sessionStorage.setItem(SESSION_FLAG, "true");
  }, [user, cdcUser]);
};

export const removeLoginTrackingFlag = (): void => {
  sessionStorage.removeItem(SESSION_FLAG);
};
